
import { useState, useEffect } from 'react';
import ApiClient from '../../API/api';

export const useCartPromotions = (productId) => {
    const [promotions, setPromotions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!productId) return;

        const fetchPromotions = async () => {
            setLoading(true);
            try {
                const url = `cart-promotions/active`;
                const response = await ApiClient.performRequest(url, {
                    queryParams: { productId }
                });
                console.log("[DEBUG] CartPromotions response for productId:", productId, response);
                setPromotions(response);
            } catch (err) {
                console.error("[DEBUG] Error fetching promotions", err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchPromotions();
    }, [productId]);

    return { promotions, loading, error };
};
